var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEhealthLogoRedC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "21.15 0 49.34 69.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,72.000000) scale(0.100000,-0.100000)",
    fill: "#be6b6b",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532 703 c-37 -18 -75 -82 -70 -116 2 -18 9 -21 33 -19 54 5 103 56 119 125 6 24 4 27 -21 27 -16 0 -43 -8 -61 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 501 c-61 -28 -120 -86 -140 -137 -19 -51 -16 -164 7 -204 51 -90 125 -134 224 -134 83 0 132 21 188 83 118 131 60 341 -112 399 -50 17 -120 14 -167 -7z m155 -86 c16 -8 31 -22 35 -30 10 -26 7 -113 -4 -120 -5 -3 -38 -11 -72 -16 -34 -6 -64 -12 -66 -14 -2 -2 0 -16 5 -32 16 -47 83 -40 83 8 0 14 7 19 30 19 27 0 30 -3 30 -31 0 -20 -10 -40 -29 -60 -24 -24 -38 -29 -76 -29 -38 0 -52 5 -76 29 -28 29 -29 32 -29 129 0 99 1 101 31 131 35 35 89 42 138 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 345 c-5 -14 -10 -30 -10 -35 0 -11 71 -1 85 12 15 14 -8 43 -39 46 -20 3 -28 -2 -36 -23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhealthLogoRedC);
export default __webpack_public_path__ + "static/media/ehealth_logo_red_c.2028c10cbe09ea3c19720d4ab0bd2fa7.svg";
export { ForwardRef as ReactComponent };